export enum ProfileStatusEnum {
  ACTION_REQUIRED = "action-required",
  OK = "ok",
  DEACTIVATED = "deactivated",
}
